var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 52.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0133 52.5zM52 52.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0152 52.5z",
    stroke: "#A5ADB1",
    strokeLinecap: "round",
    className: "fi-icon-illustrative-base-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A5ADB1",
    strokeLinecap: "square",
    d: "M51 61.517l8 5.715M22 67.231l8-5.715",
    className: "fi-icon-illustrative-base-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.601 61H29.4C25.314 61 22 57.642 22 53.504V23.496C22 19.358 25.314 16 29.399 16H51.6C55.688 16 59 19.358 59 23.496v30.008C59 57.642 55.688 61 51.601 61zM23 43.5h36M23 26.5h36",
    stroke: "#E97025",
    strokeLinecap: "round",
    className: "fi-icon-illustrative-highlight-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A5ADB1",
    strokeLinecap: "square",
    d: "M32 8.5h17",
    className: "fi-icon-illustrative-base-stroke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationTrain;